export default __webpack_public_path__ + "images/SE.0b11a07.png";